const TipoFidelizacao = Object.freeze({
   QRCODE: 'QR Code',
   CHAVE: 'Chave',
   CPF: 'CPF'
});

export default TipoFidelizacao;
